export enum ROLES_AND_PERMISSIONS_TABS {
  USERS = "users",
  ROLES = "roles",
}

export enum ROLES_AND_PERMISSIONS_POPUP {
  NONE = "",
  PUT_USER = "put-user",
  CREATE_ROLE = "create-role",
  EDIT_ROLE = "edit-role",
}
